export default __webpack_public_path__ + "static/media/icon_weight_Light.632b5551.png";